import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Stack } from "@mui/material";
import moment from "moment";
import { useQueryClient } from "react-query";
import SearchBar from "components/atoms/SearchBar";
import Pagination from "components/molecules/pagination/Pagination";
import { useCustomQuery } from "store/hooks/react-query/query/useQuery";
import { GET_STOCK_USAGE } from "utils/reactQueryKeys";

const Row = ({ row, i, currentPage }) => {
  const investigation = row?.investigationId;
  const patient = investigation?.patient;
  const test = investigation?.test;
  const patientName = patient
    ? `${patient.firstName || ""} ${patient.lastName || ""}`.trim()
    : "N/A";

  return (
    <TableRow
      sx={{
        "&:nth-of-type(odd)": { backgroundColor: "background.custom" },
        "&:last-child td, &:last-child th": { border: 0 },
      }}
    >
      <TableCell align="left">{(currentPage - 1) * 10 + i + 1}</TableCell>
      <TableCell align="left" sx={{ color: "primary.darkGrey" }}>
        {moment(row?.createdAt).format("DD/MM/YYYY hh:mm A")}
      </TableCell>
      <TableCell
        align="left"
        sx={{ color: "primary.darkGrey", textTransform: "capitalize" }}
      >
        {patientName}
      </TableCell>
      <TableCell align="left" sx={{ color: "primary.darkGrey" }}>
        {test?.testName || investigation?.uniqueCode || "N/A"}
      </TableCell>
      <TableCell align="left" sx={{ color: "primary.darkGrey" }}>
        {row?.item?.uniqueCode || "N/A"}
      </TableCell>
      <TableCell align="left" sx={{ color: "primary.darkGrey" }}>
        {row?.item?.itemName || "N/A"}
      </TableCell>
      <TableCell align="left" sx={{ color: "primary.darkGrey" }}>
        {row?.quantity}
      </TableCell>
      <TableCell align="left" sx={{ color: "primary.darkGrey" }}>
        {row?.item?.unitOfItem || "N/A"}
      </TableCell>
      <TableCell align="left" sx={{ color: "primary.darkGrey" }}>
        {row?.reason || "-"}
      </TableCell>
      <TableCell
        align="left"
        sx={{ color: "primary.darkGrey", textTransform: "capitalize" }}
      >
        {row?.usedBy
          ? `${row.usedBy.firstName || ""} ${row.usedBy.lastName || ""}`.trim()
          : "N/A"}
      </TableCell>
    </TableRow>
  );
};

export default function StockUsageHistoryTable({ data, currentPage, handlePageChange }) {
  const [search, setSearch] = React.useState("");
  const queryClient = useQueryClient();

  const {
    isLoading: searchLoading,
    isFetching,
    refetch: refetchSearch,
  } = useCustomQuery(
    [GET_STOCK_USAGE, search],
    { url: `/lab-stock/usage-history?search=${encodeURIComponent(search)}&page=1&limit=10`, method: "get" },
    {
      refetchOnWindowFocus: false,
      enabled: false,
      onSuccess: (response) => {
        queryClient.setQueryData([GET_STOCK_USAGE, currentPage], () => ({
          ...response,
        }));
      },
    }
  );

  return (
    <Stack direction="column" sx={{ width: "100%" }} spacing={2}>
      <Stack direction="row" sx={{ width: "100%", justifyContent: "flex-end" }}>
        <SearchBar
          refetch={refetchSearch}
          search={search}
          isLoading={searchLoading || isFetching}
          setsearch={setSearch}
          placeholder="Search by item, patient or user"
        />
      </Stack>
      {data?.usageHistory?.length ? (
        <>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 1000 }} aria-label="stock-usage-table">
              <TableHead>
                <TableRow>
                  {[
                    "",
                    "Date",
                    "Patient",
                    "Investigation",
                    "Item No.",
                    "Item",
                    "Quantity Used",
                    "Unit",
                    "Reason",
                    "Used By",
                  ].map((h) => (
                    <TableCell key={h} align="left" sx={{ fontWeight: "bold" }}>
                      {h}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.usageHistory.map((row, i) => (
                  <Row key={row.id || row._id || i} row={row} i={i} currentPage={currentPage} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Stack sx={{ p: { xs: 0, sm: 2 }, width: "100%" }}>
            <Pagination
              currentPage={currentPage}
              totalCount={data?.count || 5}
              pageSize={10}
              onPageChange={handlePageChange}
            />
          </Stack>
        </>
      ) : (
        "No Data Found"
      )}
    </Stack>
  );
}